import React, { PureComponent } from 'react'
import './index.scss'
import './mediaQuery.scss'

import PropTypes from 'prop-types'

export default class Template4 extends PureComponent {
  static propTypes = {
    templateInfo: PropTypes.object
  }

  render() {
    const { classTittle, classUrl, articleInfo } = this.props.templateInfo

    return (
      <div className="template template4">
        <header>
          <h3>{classTittle}</h3>
          <a
            href={classUrl}
            alt={classTittle}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="more">查看更多</span>
            <span className="arrow" />
          </a>
        </header>
        <section className="main">
          {articleInfo.map(item => (
            <div className="article" key={item.articleTittle}>
              <a href={item.linkUrl}>
                <div className="img-wrapper">
                  <img src={item.articlePic} alt={item.articleTittle} />
                </div>
                <div className="title">
                  <p>{item.articleTittle}</p>
                </div>
              </a>
            </div>
          ))}
        </section>
        <p className="m-more-wrapper">
          <a
            href={classUrl}
            alt={classTittle}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="m-more">查看更多</span>
            <span className="m-arrow" />
          </a>
        </p>
      </div>
    )
  }
}
